export type ChatScope = 'all' | 'custom' | 'mine';

export const CHAT_SCOPE_OPTIONS: {
  label: string;
  value: Exclude<ChatScope, 'custom'>;
}[] = [
  { label: 'My chats', value: 'mine' },
  { label: 'All chats', value: 'all' },
];

export function getChatScope(
  participantUserIds: string[],
  currentUserId?: string
): ChatScope {
  if (participantUserIds.length === 0) return 'all';
  if (
    participantUserIds.length === 1 &&
    participantUserIds[0] === currentUserId
  ) {
    return 'mine';
  }
  return 'custom';
}

export function getChatScopeLabel(
  scope: ChatScope,
  participantCount: number
): string {
  if (scope === 'custom') {
    return `${participantCount} participant${
      participantCount === 1 ? '' : 's'
    }`;
  }
  return (
    CHAT_SCOPE_OPTIONS.find((option) => option.value === scope)?.label ?? ''
  );
}
